export const kebabCase = (str: string): string => {
  return str.split(" ").join("-").toLowerCase();
};
